<template>
  <svg
    ref="waveSvg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1440 320"
    class="animated-wave"
  >
    <defs>
      <linearGradient id="waveGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stop-color="#fff" />
        <stop offset="100%" stop-color="#fff" />
      </linearGradient>
    </defs>
    <path
      ref="wavePathStroke"
      class="wave-path-stroke"
      d="M0,256L80,240C160,224,320,192,480,186.7C640,181,800,203,960,208C1120,213,1280,203,1360,197.3L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
    />
    <path
      ref="wavePathFill"
      class="wave-path-fill"
      fill="url(#waveGradient)"
      d="M0,256L80,240C160,224,320,192,480,186.7C640,181,800,203,960,208C1120,213,1280,203,1360,197.3L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
    />
  </svg>

  <div class="componente-completo" ref="containerRef">
    <img ref="bolaRef" src="@/assets/disco.png" alt="Bola de disco" class="bola-disco" />
    <img ref="estrellasRef" src="@/assets/estrellas.png" alt="Estrellas" class="estrellas-decorativas" />
    <img ref="fotoRef" src="@/assets/ovalada.jpg" alt="Foto destacada" class="foto-elegante" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  name: 'ComponenteCompleto',
  setup() {
    const containerRef = ref(null);
    const fotoRef = ref(null);
    const foto2Ref = ref(null);
    const bolaRef = ref(null);
    const estrellasRef = ref(null);
    const waveSvg = ref(null);
    const wavePathStroke = ref(null);
    const wavePathFill = ref(null);

    const animate = () => {
      const pathLength = wavePathStroke.value.getTotalLength();
      wavePathStroke.value.style.strokeDasharray = pathLength;
      wavePathStroke.value.style.strokeDashoffset = pathLength;

      const tl = gsap.timeline();

      tl.fromTo(waveSvg.value, { opacity: 0, y: -60 }, { opacity: 1, y: 0, duration: 1 })
        .to(wavePathStroke.value, { strokeDashoffset: 0, duration: 1.4 }, '-=0.6')
        .to(wavePathFill.value, { opacity: 1, duration: 1 }, '-=1')
        .fromTo(containerRef.value, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1.2 }, '-=0.6')
        .fromTo(fotoRef.value, { y: -120, opacity: 0, rotate: -10, scale: 0.9 }, { y: 0, opacity: 1, rotate: -4, scale: 1, duration: 1.2, ease: 'power2.out' }, '-=1')
        .fromTo(foto2Ref.value, { y: -100, opacity: 0, rotate: 10, scale: 0.9 }, { y: 0, opacity: 1, rotate: 4, scale: 1, duration: 1.2, ease: 'power2.out' }, '-=1.1')
        .fromTo(bolaRef.value, { y: -80, scale: 0.7, opacity: 0 }, { y: 0, scale: 1, opacity: 1, duration: 1.1, ease: 'back.out(1.7)' }, '-=1.1')
        .fromTo(estrellasRef.value, { y: -70, opacity: 0, scale: 0.8 }, { y: 0, opacity: 1, scale: 1, duration: 1, ease: 'power2.out' }, '-=1');
    };

    onMounted(() => {
      const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
          animate();
          obs.unobserve(entry.target);
        }
      }, { threshold: 0.3 });

      if (containerRef.value) observer.observe(containerRef.value);
    });

    return {
      containerRef,
      fotoRef,
      foto2Ref,
      bolaRef,
      estrellasRef,
      waveSvg,
      wavePathStroke,
      wavePathFill
    };
  }
};
</script>

<style scoped>
.componente-completo {
  position: relative;
  width: 100%;
  padding: 70px 0 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.animated-wave {
  width: 100%;
  height: auto;
  pointer-events: none;
  opacity: 0;
}

.wave-path-stroke {
  fill: none;
  stroke: #ffffff;
  stroke-width: 2.5;
}

.wave-path-fill {
  opacity: 0;
}

.bola-disco {
  width: 120px;
  margin-top: 0;
  transform-origin: center;
  opacity: 0;
  z-index: 1;
  margin-right: -180px;
  margin-bottom: -30px;
}

.estrellas-decorativas {
  width: 100px;
  position: absolute;
  bottom: 30px;
  right: 30px;
  opacity: 0;
  z-index: 0;
}

.foto-elegante,
.foto-elegante-reversa {
  width: 470px;
  max-width: 90%;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.35);
  opacity: 0;
  transform-origin: center;
  margin: 30px 0;
}

.foto-elegante {
  transform: rotate(-4deg);
  z-index: 2;
}

.foto-elegante-reversa {
  transform: rotate(4deg);
  z-index: 1;
}
</style>
